import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-screen" style={{ background: "#f4f1ec" }}>
      <main className="mx-auto max-w-[640px] px-5 py-10 text-neutral-800">
        <h1 className="text-3xl font-semibold">Hound Club Privacy</h1>
        <p className="mt-2 text-sm text-neutral-500">Last updated: 11 May 2026</p>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">Who we are</h2>
          <p>
            The Little Green Hound Pantry Ltd, Kensington, London is the data controller for
            information collected through Hound Club. You can reach us at{" "}
            <a className="underline" href="mailto:privacy@thelittlegreenhoundpantry.co.uk">
              privacy@thelittlegreenhoundpantry.co.uk
            </a>
            .
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">What we collect</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>Email address (required)</li>
            <li>First and last name</li>
            <li>Mobile number (optional, for receipt links only)</li>
            <li>Points earned and redeemed</li>
          </ul>
          <p>We do not collect payment card details — those stay with our till provider.</p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">Why we use it (lawful basis)</h2>
          <p>
            We process your data to operate the loyalty programme — issuing your pass,
            tracking your balance, and sending receipts you ask for. The lawful basis under
            UK GDPR is <em>contract</em> (Article 6(1)(b)). We will only contact you for
            marketing if you separately opt in.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">Who we share it with</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li><strong>StockClerk</strong> — issues and updates your Apple Wallet pass</li>
            <li><strong>Apple</strong> — delivers pass updates to your iPhone</li>
            <li><strong>EposNow</strong> — our till system, records points earned</li>
          </ul>
          <p>We never sell your data. All processors are bound by data-processing agreements.</p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">How long we keep it</h2>
          <p>
            We keep your account for as long as you are an active member, plus 24 months of
            inactivity. After that, we delete or anonymise your record.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">Your rights</h2>
          <p>
            You have the right to access, correct, delete, or export your data, and to object
            to processing. Email{" "}
            <a className="underline" href="mailto:privacy@thelittlegreenhoundpantry.co.uk">
              privacy@thelittlegreenhoundpantry.co.uk
            </a>{" "}
            and we'll respond within 30 days. You can also complain to the ICO at{" "}
            <a className="underline" href="https://ico.org.uk" target="_blank" rel="noreferrer">
              ico.org.uk
            </a>
            .
          </p>
        </section>

        <Link to="/" className="mt-8 inline-block underline">← Back to enrolment</Link>
      </main>
    </div>
  );
}
